import { runApiCall } from './api-config';

export async function importCommitStructured(data) {
    const res = await runApiCall('POST', 'assets/import_utility_uses/commit_structured/', data);
    return res.data;
}
